import { Pipe, PipeTransform } from '@angular/core';
import { SiteType } from 'src/api/models';

@Pipe({
    name: 'siteTypeFilter'
})
export class SiteTypeFilterPipe implements PipeTransform {

    transform(items: any[], search?: any): any {
        if (!items || search == null) {
            return items;
        }
        const tokens = search.toLowerCase().split(' ');
        var results = items;
        for (let token of tokens){
            results = results.filter(item => 
                item.siteDescription?.toLowerCase()?.indexOf(token) > -1
                || item.siteName.toLowerCase().indexOf(token) > -1
            );
        }         
        return results;
    }
}